import React from "react";

import { AnalyticsPage } from "./analytics_page";
import { AnalyticsContextProvider, AnalyticsTab } from "./context/analytics_context";
import { AnalyticsModalContextProvider } from "./parts/top_actions_panel/analytics_modal_context_provider";

type AnalyticsControllerProps = {
  tab: AnalyticsTab;
};

export const AnalyticsController = ({ tab }: AnalyticsControllerProps) => {
  const initPage = {
    tab
  };

  return (
    <AnalyticsContextProvider initPageData={initPage}>
      <AnalyticsModalContextProvider>
        <AnalyticsPage />
      </AnalyticsModalContextProvider>
    </AnalyticsContextProvider>
  );
};
